module.exports = {"audiences":["allMembers"],"experimentVersion":"v2","experimentAllocation":1,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"V2","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/teamMembersTabLayout.json
// module id = 5FtJ
// module chunks = 2